import crud_actions from './crud_actions'

export const loginWithEmail = crud_actions.read('profile', 'loginWithEmail')
export const forgotPassword = crud_actions.update(
  'password-reset',
  'forgotPassword'
)
export const loginWithFacebook = crud_actions.read(
  'profile',
  'loginWithFacebook'
)
export const loadProfile = crud_actions.read('profile')
export const updateProfile = crud_actions.update('profile')
export const logout = crud_actions.read('logout', 'logout')
export const loginWithJwt = crud_actions.read('profile', 'loginWithJwt')
